import { Action } from './framework'
import { combineEpics } from 'redux-observable'

export const appEpics = combineEpics<Action<any>>()



// WEBPACK FOOTER //
// ./src/app.epics.ts